import { TooltipModel, TooltipModelProps } from '@mail/3promo/models/tooltip';
import { ReactRenderer } from '@mail/3promo/render/react';
import { LocalStorageStore } from '@mail/3promo/stores/localStorage';
import type { ModelCreator } from '@mail/3promo/types';
import { xray } from 'lib/xray';
import { PdfWorkWithPagesPromo } from 'reactApp/modules/promoNew/components/PdfWorkWithPages/PdfWorkWithPagesPromo';
import { PDF_WORK_WITH_PAGES_PROMO } from 'reactApp/modules/promoNew/defaultValues';

export const pdfWorkWithPagesCreator: ModelCreator = ({ models, render, stores }) =>
    new TooltipModel(
        PDF_WORK_WITH_PAGES_PROMO,
        models.base,
        new TooltipModelProps(PDF_WORK_WITH_PAGES_PROMO, {
            store: new LocalStorageStore(PDF_WORK_WITH_PAGES_PROMO, stores.localStorage),
            renderer: new ReactRenderer(PDF_WORK_WITH_PAGES_PROMO, PdfWorkWithPagesPromo, render.react),
            closable: true,
            hideOnOutsideClick: true,
            templateData: {
                title: 'Работайте со страницами',
                text: 'Измените расположение, добавьте или удалите лишние страницы',
                buttons: {
                    complete: 'Попробовать',
                },
            },
            getTarget: () => {
                return document.querySelector("[data-qa-id='pdf-work-with-pages-new-promo-target']");
            },
            onShow: () => {
                xray.send(`pdf_work_with_pages_promo_show`);
            },
            onClose: () => {
                xray.send(`1-pdf_work_with_pages_promo_close_button`);
            },
            onComplete: () => {
                xray.send(`2-pdf_work_with_pages_promo_close_сomplete`);
            },
        })
    );
